export const products = [
  {
    id: "game-companion",
    name: "陪玩交友系统",
    category: "社交娱乐",
    description: "从陪玩师入驻到预约履约，连接游戏用户与陪玩交友服务。",
    tags: ["服务商品", "预约订单", "履约结算"],
    ready: true,
    status: "规划中",
  },
  {
    id: "voice",
    name: "语音直播交友",
    category: "社交娱乐",
    description: "以语音房为核心，提供多人上麦、房间互动与语音交友场景。",
    tags: ["语音房", "麦位管理", "房间互动"],
    ready: true,
  },
  {
    id: "live",
    name: "多人直播交友系统",
    category: "社交娱乐",
    description: "覆盖主播开播、多人连麦与直播间互动，构建直播交友场景。",
    tags: ["主播开播", "多人连麦", "礼物互动"],
    ready: true,
  },
  {
    id: "one-to-one",
    name: "1对1直播系统",
    category: "社交娱乐",
    description: "面向一对一语音与视频交流，了解通话流程及互动能力。",
    tags: ["语音通话", "视频通话", "即时交流"],
    ready: true,
  },
  {
    id: "overseas",
    name: "海外直播1对1交友系统",
    category: "社交娱乐",
    description: "面向海外直播与一对一交友场景，查阅功能、演示与技术资料。",
    tags: ["海外直播", "1对1交友", "运营支持"],
    ready: true,
  },
  {
    id: "rental",
    name: "租赁系统",
    category: "商业经营",
    description: "面向设备租赁业务，了解租赁下单、设备管理与售后流程。",
    tags: ["设备管理", "租赁订单", "售后工单"],
    ready: false,
  },
  {
    id: "commerce",
    name: "商城系统",
    category: "商业经营",
    description: "面向线上零售业务，集中查看商城产品与交付资料。",
    tags: ["线上商城", "交易业务"],
    ready: false,
  },
  {
    id: "quant",
    name: "量化交易系统",
    category: "行业应用",
    description: "量化交易产品的功能范围、演示与技术资料统一入口。",
    tags: ["产品资料", "技术文档"],
    ready: false,
  },
  {
    id: "booking",
    name: "上门预约",
    category: "行业应用",
    description: "面向预约服务场景，了解产品功能与业务交付范围。",
    tags: ["预约服务", "业务流程"],
    ready: false,
  },
];
export const sections = [
  { slug: "demo", label: "系统演示" },
  { slug: "features", label: "功能介绍" },
  { slug: "architecture", label: "技术框架" },
];
